<script lang="ts" setup>
    import useAcfOptions from "../../composables/use-acf-options";
    import useMenu from "../../composables/use-menu";
    import usePage from "../../composables/use-page";
    import { useRoute } from "vue-router";

    const props = defineProps<{
        page: any
    }>();

    const route = useRoute();
    const page = props?.page;
    const currentPage = route.path.toString();
    const menu: any = await useMenu('main-menu');
    let fixedNavClass = '';
    let menuItemColorClass = 'text-white';

    if (page?.pageBuilder?.isNavFixed) {
        fixedNavClass = 'nav-fixed nav-fixed-light';
        menuItemColorClass = 'text-green-light';
    }

    const darkLogo: any = await useAcfOptions('nav_fixed_logo');
    const mainLogo: any = await useAcfOptions('main_logo');

    useHead({
        link: [
            {
                href: mainLogo.url,
                fetchpriority: 'high',
                rel: 'preload',
                as: 'image',
            },
            {
                href: darkLogo.url,
                fetchpriority: 'high',
                rel: 'preload',
                as: 'image',
            }
        ],
    });

    let activeMenu = '';

    // Normalize current page path by removing trailing slash
    const normalizedCurrentPage = currentPage.replace(/\/$/, '') || '/';

    menu?.menuItems?.nodes.forEach((navMenu: any) => {
        // Normalize menu URI by removing trailing slash
        const normalizedMenuUri = navMenu?.uri?.replace(/\/$/, '') || '/';

        if (normalizedCurrentPage.startsWith(normalizedMenuUri) && normalizedMenuUri !== '/') {
            activeMenu = navMenu?.uri;
            return;
        } else if (navMenu?.childItems?.nodes?.length > 0) {
            navMenu?.childItems?.nodes.forEach((childMenu: any) => {
                // Normalize child menu URI by removing trailing slash
                const normalizedChildUri = childMenu?.uri?.replace(/\/$/, '') || '/';

                if (normalizedCurrentPage.startsWith(normalizedChildUri) && normalizedChildUri !== '/') {
                    activeMenu = navMenu?.uri;
                    return;
                }
            });
        }
    });

</script>
<template>
    <nav id="navbar" :class="`navbar navbar-expand-md border-0 fixed-top pb-0 pt-0 ${fixedNavClass} d-none d-md-block`">
        <div class="container-xl flex-nowrap">
            <div class="navbar-nav justify-content-xl-end flex-grow-1 bg-transparent mt-4">
                <ul id="desktop-nav-ul" class="navbar-nav d-flex justify-content-between w-100 align-items-center">
                    <template v-for="(item, index) in menu?.menuItems?.nodes">
                        <template v-if="index === Math.floor(menu.menuItems.nodes.length / 2) - 1">
                            <li :class="`d-flex justify-content-center nav-item btn rounded-pill ${activeMenu === item?.uri ? 'btn btn-primary rounded-pill current-nav' : 'btn-nav-menu'} ${item?.childItems?.nodes.length > 0 ? 'navbar-dropdown dropdown' : ''}`">
                                <div class="label-wrapper">
                                    <h5><a :class="`menu-text text-uppercase ${menuItemColorClass}`" :href="item?.uri">{{ item?.label }}</a></h5>
                                </div>
                                <ul v-if="item?.childItems?.nodes.length > 0" class="dropdown-menu">
                                    <a v-for="child in item?.childItems?.nodes" :class="`text-uppercase text-green-light`" :href="child?.uri">
                                        <li :class="`dropdown-item text-green-light ${currentPage.startsWith(child?.uri) ? 'current-nav-child' : ''}`">
                                            {{ child?.label }}
                                        </li>
                                    </a>
                                </ul>
                            </li>
                            <li class="header-logo nav-item d-block py-2">
                                <a href="/">
                                    <NuxtImg id="header-logo-light"
                                    class="logo-light"
                                    src="/marella-header-light.svg" width="188" height="100"
                                    alt="Marella Homes"
                                    :quality="80"/>
                                    <NuxtImg id="header-logo-dark"
                                    class="logo-dark"
                                    src="/marella-header-dark.svg" width="188" height="100"
                                    alt="Marella Homes"
                                    quality="80"/>
                                </a>
                            </li>
                        </template>
                        <template v-else>
                            <li :class="`d-flex justify-content-center nav-item btn rounded-pill ${activeMenu === item?.uri ? 'btn btn-primary rounded-pill current-nav' : 'btn-nav-menu'} ${item?.childItems?.nodes.length > 0 ? 'navbar-dropdown dropdown' : ''}`">
                                <div class="label-wrapper">
                                    <h5><a :class="`menu-text text-uppercase ${menuItemColorClass}`" :href="item?.uri">{{ item?.label }}</a></h5>
                                </div>
                                <ul v-if="item?.childItems?.nodes.length > 0" class="dropdown-menu">
                                    <a v-for="child in item?.childItems?.nodes" :class="`text-uppercase text-green-light`" :href="child?.uri">
                                        <li :class="`dropdown-item text-green-light ${currentPage.startsWith(child?.uri) ? 'current-nav-child' : ''}`">
                                            {{ child?.label }}
                                        </li>
                                    </a>
                                </ul>
                            </li>
                        </template>
                    </template>
                </ul>
            </div>
        </div>
    </nav>
</template>